'use client';

import { Align, Column, Columns, Icon, IconName, IconSize, Row, Rows, Text, TextLevels } from '@bytel/trilogy-react';

import { FaiProduct } from '@app-types/fai';

export function BBoxDetail({ selectedFaiProduct }: Readonly<{ selectedFaiProduct?: FaiProduct | null }>) {
    if (!selectedFaiProduct) {
        return null;
    }
    const speedDown = selectedFaiProduct.pre_elig_speed_down
        ? `${selectedFaiProduct.pre_elig_speed_down} Gb/s`
        : selectedFaiProduct.speedDown;
    const speedUp = selectedFaiProduct.pre_elig_speed_up
        ? `${selectedFaiProduct.pre_elig_speed_up} Gb/s`
        : selectedFaiProduct.speedUp;
    const speedWording = selectedFaiProduct.pre_elig_speed_wording;
    const sortedNuggets =
        selectedFaiProduct.nuggets?.length > 0
            ? [...selectedFaiProduct.nuggets]?.sort((a, b) => {
                  const positionA = a.position ?? Number.MAX_SAFE_INTEGER;
                  const positionB = b.position ?? Number.MAX_SAFE_INTEGER;
                  return +positionA - +positionB;
              })
            : [];

    return (
        <Rows gap={3}>
            {sortedNuggets?.map((nugget) => {
                return (
                    <Row key={nugget.texte}>
                        <Columns mobile gap={4} verticalAlign={Align.CENTER}>
                            <Column narrow>
                                <Icon name={nugget.logo_nuggets as IconName} size={IconSize.SMALL} />
                            </Column>
                            <Column>
                                <Text level={TextLevels.TWO} marginless>
                                    {nugget.texte}
                                    {speedWording && nugget.show_speed && ' ' + speedWording}
                                </Text>
                                {selectedFaiProduct && nugget.show_speed && (
                                    <Text level={TextLevels.TWO}>
                                        &nbsp;↓&nbsp;{speedDown} ↑&nbsp;{speedUp}
                                    </Text>
                                )}
                            </Column>
                        </Columns>
                    </Row>
                );
            })}
        </Rows>
    );
}
